import { render } from "./MinMaxTemperatures.vue?vue&type=template&id=1a4476f9&scoped=true"
import script from "./MinMaxTemperatures.vue?vue&type=script&lang=js"
export * from "./MinMaxTemperatures.vue?vue&type=script&lang=js"

import "./MinMaxTemperatures.vue?vue&type=style&index=0&id=1a4476f9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4476f9"]])

export default __exports__